import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
// Vendors
import Keycloak from 'keycloak-js';
import cookies from "../cookies/cookies";
import session from "../session/session.utils";
// Constants
import constants from "./constants/usd.constants";
// Core
import setupUsdCore from "./core/usd.core";
// Types

var keycloak;
var initKeycloak = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var _window$location, _window$location$host;
            keycloak = Keycloak(constants.KEYCLOAK_CONFIG);
            var currentDomain = (_window$location = window.location) !== null && _window$location !== void 0 && (_window$location$host = _window$location.hostname) !== null && _window$location$host !== void 0 && _window$location$host.includes('localhost') ? '' : '.zinia.com';
            keycloak.init({
              onLoad: 'login-required',
              checkLoginIframe: false
            }).then(function (authenticated) {
              authenticated && cookies.setCookie({
                name: 'agentToken',
                value: keycloak.token,
                domain: currentDomain
              });
              window.setAgentClientData(generateFakeUsdInit());
            })["catch"](function () {
              return reject();
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initKeycloak() {
    return _ref.apply(this, arguments);
  };
}();
var isLocalDevelopment = function isLocalDevelopment() {
  return new RegExp(/localhost/).test(window.location.hostname);
};
export var generateFakeUsdInit = function generateFakeUsdInit() {
  window.console.log('CC fake init called');
  var createInteractionId = function createInteractionId() {
    var letters = '0123456789abcdef';
    var interactionId = '';
    for (var i = 0; i < 16; i++) {
      interactionId += letters[Math.floor(Math.random() * 16)];
    }
    return interactionId;
  };
  return {
    agentToken: cookies.getCookie('agentToken'),
    country: 'NL',
    email: 'customeremail@gmail.com',
    documentType: 'phone',
    interactionId: '8be3cc9e83a0227c',
    platform: 'CC',
    securitySSR_AccessToken: '',
    securitySSR_RefreshToken: '',
    sessionId: createInteractionId(),
    firstName: 'Antonio',
    lastName: 'Resines',
    userName: 'customeremail@gmail.com',
    /**
     * USD communicates UI USD raises N1
     * @constructor
     */
    AssistedAuthenticateSuccess: function AssistedAuthenticateSuccess() {
      window.console.log('Assisted success authentication');
      window.location.replace('/overview');
    },
    GetAgentAccessToken: function GetAgentAccessToken() {
      window.console.log('Renew agent access token');
      Keycloak(constants.KEYCLOAK_CONFIG).updateToken().then(function () {
        return window.USD.refreshAgentToken(keycloak.token);
      })["catch"](function () {
        session.clearSessionData();
      });
    },
    OnLogoutSuccess: function OnLogoutSuccess() {
      window.location.href = '/assisted-login';
    },
    OnInvalidSession: function OnInvalidSession() {
      window.location.href = '/assisted-login';
    },
    RaiseN2InIvr: function RaiseN2InIvr() {},
    SignatureKeyExpired: function SignatureKeyExpired() {}
  };
};
var setUSDCommunicationMethods = function setUSDCommunicationMethods(callback) {
  window.setAgentClientData = function (usdInformation) {
    if (!isLocalDevelopment()) {
      // We need to ensure to clear each time loads to remove all data storaged
      session.clearSessionData();
    }
    window.USD.init(usdInformation);
    callback && callback();
  };
  window.refreshAgentToken = function (agentToken) {
    window.USD.refreshAgentToken(agentToken);
  };
  window.notifyAgentToken = function () {
    return null;
  }; // Alejandro pending

  window.invalidateSessionTokens = function () {};
  window.refreshSessionTokens = function (accessToken, refreshToken) {
    return {
      accessToken: accessToken,
      refreshToken: refreshToken
    };
  };
  window.notifyInteractionEnded = function () {};
  window.RaiseN2InIvrSuccess = function () {};
  window.RaiseN2InIvrFailure = function (errorType) {
    return {
      errorType: errorType
    };
  };
  window.updateSignatureKeySuccess = function () {};
  window.updateSignatureKeyFailure = function (errorType) {
    return {
      errorType: errorType
    };
  };
};
var setupUSDInit = function setupUSDInit(callback) {
  setupUsdCore();
  setUSDCommunicationMethods(callback);
  if (isLocalDevelopment()) {
    window.setAgentClientData(generateFakeUsdInit());
  }
};
var usd = {
  setupUSDInit: setupUSDInit,
  initKeycloak: initKeycloak,
  core: function core() {
    return window.USD;
  }
};
export default usd;